module.exports = __webpack_public_path__ + "img/t2-c29.669635d1.png";